import { classNames } from "primereact/utils"
import type { FC, PropsWithChildren } from "react"

const Sheet: FC<PropsWithChildren<Props>> = ({ children, className }) => {
  return (
    <main className={classNames("relative flex min-h-screen w-full flex-col items-center overflow-x-hidden", className)}>
      {children}
    </main>
  )
}

type Props = {
  className?: string
}

export { Sheet }
